import { registerStore } from "@mirage-web/utils/root-store";

import { createAuthStore } from "~/modules/auth/auth-store";

import { createConfigStore } from "./config";

export function registerPrimaryStores() {
  registerStore("config", createConfigStore);

  registerStore("auth", createAuthStore);
}
